import { Box, Typography } from '@mui/material';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import { useTheme } from '@mui/material/styles';
import { memo } from 'react';
import strings from '../../../Globalization';
import DigitalGraph from '../../../components/common/DigitalGraph';

const ContactChart = ({ title, data, sx, unit }) => {
	const theme = useTheme();
	const color = Number(data.SetTime) > Number(data.ActualTime) ? theme.palette.error.light : theme.palette.success.light;
	return (
		<>
			<Box display="flex" textAlign="center" sx={sx}>
				<Typography flex={1} fontWeight="bold" variant="body2" gutterBottom>
					{title} {unit}
				</Typography>
				<TimerOutlinedIcon />
			</Box>
			<Box p={1}>
				<DigitalGraph title={strings.SetTime} value={data.SetTime} />
				<DigitalGraph title={strings.RecordedTime} value={data.ActualTime} color={color} />
			</Box>
		</>
	);
};

export default memo(ContactChart);